"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSortingDropdownBody = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Overlay_1 = require("../Overlay");
var dropdownAlignPoints = [{ align: "bl tl" }];
/**
 * @internal
 */
exports.ChartSortingDropdownBody = function (_a) {
    var children = _a.children, onClose = _a.onClose;
    var getDialogClasses = function () {
        return classnames_1.default([
            "overlay",
            "gd-dialog",
            "gd-dropdown",
            "gd-sort-charting-dropdown",
            "gd-sort-charting-dropdown-wide",
            "s-sort-charting-dropddown",
        ]);
    };
    return (react_1.default.createElement(Overlay_1.Overlay, { alignTo: ".s-chart-sorting-button", alignPoints: dropdownAlignPoints, closeOnOutsideClick: true, closeOnParentScroll: true, closeOnMouseDrag: true, onClose: onClose },
        react_1.default.createElement("div", { className: getDialogClasses() }, children)));
};
//# sourceMappingURL=ChartSortingDropdownBody.js.map